// Modules
import { withFormik } from 'formik'
import * as H from 'history'
import React from 'react'

// Application
import { ContactData, ContactLoginStatus, ContactTypes, PatientInfoInput } from 'typings/signup'
import { PhoneSchema } from './validation'

// Components
import { ROUTES_PATH } from 'constants/routesPath'
import { CreatePatientType } from 'typings/account'
import { FormValues, InnerForm } from '../InnerForm'

export interface WrapperProps {
    cellphone?: ContactData
    setContactPhone: (phone: ContactData) => Promise<void>
    patient: PatientInfoInput
    history: H.History
    createPatientAccount: (patient: PatientInfoInput) => Promise<CreatePatientType>
    setIsLoading: (loading: boolean) => void
    validateLoginContact(contactType: ContactTypes, contactValue: string): Promise<ContactLoginStatus>
}

export const Wrapper: React.ComponentType<WrapperProps> = withFormik<WrapperProps, FormValues>({
    mapPropsToValues: ({ cellphone }) => ({
        cellphone: cellphone?.value || '',
    }),
    validationSchema: PhoneSchema,
    handleSubmit: async (values, formikBag) => {
        const { props, setFieldError } = formikBag
        const { cellphone } = values

        try {
            props.setIsLoading(true)
            const status = await props.validateLoginContact(ContactTypes.MOBILE, cellphone)
            if (status === ContactLoginStatus.CONTACTLINKED) {
                props.setIsLoading(false)
                setFieldError('cellphone', 'Telefone já cadastrado na plataforma')
                return
            }
            const validateContact: ContactData = { value: cellphone }

            await props.setContactPhone(validateContact)
            await props.createPatientAccount({ ...props.patient, cellphone })

            props.setIsLoading(false)
            props.history.push(ROUTES_PATH.SIGN_UP_VALIDATE_TOKEN)
        } catch {
            props.setIsLoading(false)
            setFieldError('cellphone', 'Ocorreu um erro. Tente novamente mais tarde')
        }
    },
})(InnerForm)
